import { render, staticRenderFns } from "./PedidosAsesoresModal.vue?vue&type=template&id=6b8b0d8b"
import script from "./PedidosAsesoresModal.vue?vue&type=script&lang=js"
export * from "./PedidosAsesoresModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports